module.exports = require("./mgo.d.ts");